React = require 'react'
_ = require 'underscore'
Auth = require 'db/auth'
Util = require 'lib/util'
Label = require 'models/label'
t = require('views/internal/recup-with-helpers')()
localizeCount = require 'lib/localize-count'
TFM = require 'lib/markdown/tfm'
MemberAvatar = require 'views/member/member-avatar-react'
Member = require 'models/member'
{ CanonicalCard } = require 'views/canonical-card/canonical-card-components'
HomeUpNextCardInfoCompenent = require 'views/home/home-up-next-card-info-component'
{ BoardAndCommentContainer } = require '@atlassian/trello-canonical-components/canonical-card'

module.exports = class HomeUpNextCardComponent extends React.Component
  displayName: 'HomeUpNextCardComponent'

  constructor: ({ board, item, modelCache }) ->

    @action = item.type == 'action'
    @actionItem = item.data?.action
    @actionMemberCreator = if @actionItem then new Member(@actionItem?.memberCreator, modelCache: modelCache)

    @isEdited = @actionItem && @actionItem.data?.dateLastEdited
    @isComment = @actionItem?.type == 'commentCard' && @actionMemberCreator
    @isAddMemberToCard = @actionItem?.type == 'addMemberToCard' && @actionMemberCreator

    @canReply = (@isComment || @isAddMemberToCard) && board?.canComment(Auth.me())

    @state = {
      isReplying: false
      replyMessage: if @canReply && !Auth.isMe(@actionMemberCreator) then "@#{@actionMemberCreator?.get('username')} " else ''
    }

    @onReplyClick = @onReplyClick.bind(@)
    @onSaveClick = @onSaveClick.bind(@)
    @onCancelClick = @onCancelClick.bind(@)
    @onChangeReplyMessage = @onChangeReplyMessage.bind(@)

    @trackOnClickCanonicalCard = @trackOnClickCanonicalCard.bind(@)
    @dismissCard = @dismissCard.bind(@)
    @onCompleteClick = @onCompleteClick.bind(@)

  onReplyClick: ->
    @setState (prevState) -> isReplying: !prevState.isReplying

  onCancelClick: ->
    @setState isReplying: false

  onChangeReplyMessage: (e) ->
    Util.preventDefault(e)
    @setState replyMessage: e.target.value

  onSaveClick: ->
    if @canReply
      { card, optimisticallyDismissCard } = @props

      card.addComment(@state.replyMessage)
      optimisticallyDismissCard(card.id)

  dismissCard: ->
    cardId = @props.card.get('id')
    upNextId = @props.upNextId

    @props.dismissCard(cardId, upNextId)

  onCompleteClick: ->
    { card, optimisticallyDismissCard } = @props

    card.update({ dueComplete: true })
    optimisticallyDismissCard(card.id)

  trackOnClickCanonicalCard: ->
    # TODO: add tracking

  render: t.renderable ->
    { upNextId, card, board, item, org, list, modelCache } = @props
    { isReplying, replyMessage } = @state

    t.li '.up-next-card-list-item', { key: upNextId }, =>

      t.tag BoardAndCommentContainer, =>
        t.div { onClick: @trackOnClickCanonicalCard }, =>
          t.tag CanonicalCard, {
            board
            boardClassName: 'canonical-stretch'
            canRemove: false
            card
            cardClassName: 'canonical-stretch'
            labels: card.getLabels()?.sort(Label.compare)
            list
            members: card.memberList?.models
            numNotifications: 0
            organization: org
            lightBackground: true
          }

        t.div =>
          t.tag HomeUpNextCardInfoCompenent, {
            board
            date: @actionItem?.date
            isEdited: @isEdited
            memberCreator: Auth.me()
            actionMemberCreator: @actionMemberCreator
            comment: if @isComment then TFM.comments.format(@actionItem?.display?.entities?.comment?.text).output
            isAddMemberToCard: @isAddMemberToCard
            dueSoon: item.type == 'dueSoon'
            canReply: @canReply
            dueDate: card.get('badges')?.due
            isReplying
            replyMessage
            onChangeReplyMessage: @onChangeReplyMessage
            onReplyClick: @onReplyClick
            onCancelClick: @onCancelClick
            onSaveClick: @onSaveClick
            onDismissClick: @dismissCard
            onCompleteClick: @onCompleteClick
          }



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-up-next-card-component.coffee